module.exports = __webpack_public_path__ + "img/avatar-purple.5edb7e60.png";